const NA = () => {
  return <div className="text-on_surface font_data_number_s">-</div>;
};

export default NA;
